module.exports = __webpack_public_path__ + "static/media/color.a43b1207.jpeg";